import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const filtros = {
	state: {
		filtros : {
			candidaturas : {
				estado : [],
				text : '',
				type : '',
			},
			ofertas : {
				comun : {},
				date : 0,
				text : {
					titulo : '',
					provincia : '',
					titulaciones : '',
					empresa: '',
					sector: ''
				},
				omitirInscritos : false,
				interna: false,
				fechainicio : '',
			},
			misofertas : {
				estado : [],
				date : 0,
				titulo :'',
				type : [],
				omitirLeidos : false,
				caducanPronto : false,
				soloConCandidatos : false
			},
			recursos: {
				area : '',
				tipo : '',
				text : ''
			},
			talleres: {
				titulo : '',
				fecha : '',
				tipo : ''
			}
		}
	},
	getters: {
		getfiltroscandidaturas : state => state.filtros.candidaturas,   
		getfiltrosofertas : state => state.filtros.ofertas,   
		getfiltrosmisofertas : state => state.filtros.misofertas,
		getfiltrosrecursos: state => state.filtros.recursos,   
		getfiltrostalleres: state => state.filtros.talleres,
	}, 
	actions: {
		requestSetFiltroCandidatura : function({commit}, data){
			commit('setfiltrosCandidaturas',data);
		},
		requestSetFiltroOfertas : function({commit}, data){
			commit('setfiltrosOfertas',data);
		},
		requestSetFiltroMisOfertas : function({commit}, data){
			commit('setfiltrosMisOfertas',data);
		},
		requestSetFiltroRecursos : function({commit}, data){
			commit('setfiltrosRecursos',data);
		},
		requestSetFiltroTalleres : function({commit}, data){
			commit('setfiltrosTalleres',data);
		}
	},
	mutations: {
		setfiltrosCandidaturas : function(state,data){
			state.filtros.candidaturas = data;
		},
		setfiltrosOfertas : function(state,data){
			state.filtros.ofertas = data;
		},
		setfiltrosMisOfertas : function(state,data){
			state.filtros.misofertas = data;
		},
		setfiltrosRecursos : function(state,data){
			state.filtros.recursos = data;
		},
		setfiltrosTalleres : function(state,data){
			state.filtros.talleres = data;
		}
	}
}

export default filtros;



// WEBPACK FOOTER //
// ./src/store/filtros.js